var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logoSmall_svg__clip0_19531_96653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.038 19.385V.308h-4.923v8.978a14.63 14.63 0 00-3.095-4.652C5.94.554.5.308.5.308s.246 5.437 4.326 9.52c2.886 2.883 6.462 3.852 8.29 4.172v9.692h14.769v-4.307h-9.847z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.278 19.883c-4.055 0-5.249-3.424-5.569-6.037h5.403A4.308 4.308 0 0045.42 9.54h-9.597c.458-2.523 1.794-5.419 5.455-5.419a8.234 8.234 0 014.339 1.17l1.867-3.828A12.729 12.729 0 0041.278 0c-7.384 0-9.683 5.385-10.363 9.539h-5.188v4.307h4.957C30.938 18.006 32.769 24 40.838 24c2.963 0 5.268-.695 7.056-1.754v-4.615c-1.351 1.292-3.419 2.252-6.616 2.252z",
    fill: "url(#logoSmall_svg__paint0_linear_19531_96653)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logoSmall_svg__paint0_linear_19531_96653",
    x1: 25.727,
    y1: 12.225,
    x2: 47.894,
    y2: 12.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B83E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B67D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "logoSmall_svg__clip0_19531_96653"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h47.385v24H0z"
  })))));
}

export default SvgLogoSmall;